module.exports = __webpack_public_path__ + "static/img/banner.a948b854.png";